import React from 'react'
import { useNavigation } from '@react-navigation/native'
import type { NavigationProp } from '@react-navigation/native'

import { Images } from 'APP/Themes'

import { useChatContext, usePostContext } from 'APP/Lib/Context'
import { channelToTimeStampForNewPost } from 'APP/Lib/MessagingHelpers'
import { useDispatch } from 'APP/Hooks/redux'
import PatientHistoryActions from 'APP/Redux/PatientHistoryRedux'
import Analytics from 'APP/Services/Analytics'
import Card from 'APP/Components/Chat/Card'

interface SendAnswerReply {
  payload: unknown
  display: string
  question_type: string
  answer_flags: unknown
}

const Booking: React.FC = () => {
  const { channelId, userId, conversation } = useChatContext()
  const { post, isLastPost } = usePostContext()
  const navigation = useNavigation<NavigationProp<any>>()
  const dispatch = useDispatch()

  const sendAnswer = (reply: SendAnswerReply): void => {
    // Note: question_type and answer_flags come from the useCompatibility
    // wrapper of sendAnswer
    const { payload, display, question_type, answer_flags } = reply

    dispatch(
      PatientHistoryActions.submitAnswerPostRequest(
        // @ts-expect-error FIXME: make this required for the ChatContext upstream
        channelId,
        userId,
        {
          text: display,
          data: payload,
          question_type,
        },
        channelToTimeStampForNewPost(conversation),
        answer_flags
      )
    )
    // @ts-expect-error FIXME: channelId is required here, but not guaranteed to be truthy by ChatContext
    dispatch(PatientHistoryActions.updateChannelLastViewed(channelId))
  }

  const onPress = (): void => {
    navigation.navigate('appointmentBookingScreen', { post, sendAnswer })

    Analytics.trackEvent('button_click', {
      button_value: `Open Appointment Booking`,
    })
  }

  // Don't render if its not the last post
  if (!isLastPost) return null
  else {
    return (
      <Card
        title={post?.message || ''}
        iconSrc={Images.appointmentBooking}
        onPress={onPress}
        testID="APPOINTMENT_BOOKING_CARD"
      />
    )
  }
}

export default Booking
